// extracted by mini-css-extract-plugin
export var csatScore = "_lz-5";
export var header = "_lz-1";
export var panelWrapper = "_lz-2";
export var postPreview = "_lz-3";
export var rightContent = "_lz-0";
export var wrappingText = "_lz-4";